import { useAuth } from "@/context/AuthContext";
import AdminApp from "@/components/admin/AdminApp";
import ArtistApp from "@/components/artist/ArtistApp";
import LabelApp from "@/components/label/LabelApp";
import PendingScreen from "@/components/dashboard/PendingScreen";

export default function Dashboard() {
  const { user } = useAuth();
  if (!user) return null;
  if (user.role === "super_admin") return <AdminApp />;
  if (user.role === "label") return <LabelApp />;
  if (user.role === "artist") return <ArtistApp />;
  return <PendingScreen />;
}
